import { Link } from '@bpba/ui-components';
import { IIndexable } from '../model/IIndexable';
import { ProductoData } from '../model/ProductoData';
import { DETALLE_PATH } from '../components/detalle/Detalle';

export function productoDataMapping(item: IIndexable) {
  const enlace =
    item?.productoId && typeof item.productoId === 'string' && item.productoId.trim().length > 0
      ? new Link(`${process.env.PUBLIC_URL}${DETALLE_PATH}/${item.productoId.trim()}`)
      : undefined;

  return new ProductoData(
    item.id,
    item.orden,
    item.titulo,
    item.descripcion,
    item.puntos,
    item.codigo,
    item.destacado,
    item.tipoProducto,
    item.rubroTitle,
    item.imagenes,
    item.rubroId,
    item.productoId,
    enlace,
    item.stock,
    item.iconoRubro,
    item.descripcionDetallada,
    item.productosRelacionados?.map((relacionado: IIndexable) => productoDataMapping(relacionado)),
    item.descuento,
    new Link(item.link?.ruta, item.link?.isExterno, item.link?.abreSolapa, item.link?.tag)
  );
}
